import { ConciergeProductKnowledgeParser } from "@redotech/redo-concierge-settings-common/product-knowledge";
import * as z from "zod";

export const getProductSettings = {
  name: "getProductSettings" as const,
  input: z.object({ identifier: z.string() }),
  output: z.object({
    productName: z.string(),
    hidden: z.boolean(),
    knowledge: ConciergeProductKnowledgeParser.optional(),
  }),
};
